<template>
	<div>
		<div class="sk-widget-title">Summary</div>
		<div class="sk-widget-alt" @click="cartSummaryClicked">
			<div>
				<div class="sk-widget-cart-summary-title">Your Order</div>
				<div class="sk-widget-cart-summary-items">
					<i class="sk-icon-shopping-cart-solid"></i>
					{{ itemsInCartCount }}
					{{ itemsInCartCount | pluralize("Item") }}
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.sk-widget-cart-summary-title {
	font-size: 16px;
	font-weight: 600;
	color: var(--gR-base-80);
	margin-bottom: 10px;
}

.sk-widget-cart-summary-items i,
.sk-widget-cart-summary-items {
	font-size: 10px;
}

.sk-widget-cart-summary-items i {
	color: var(--sk-grey2);
	margin-right: 10px;
}

.sk-widget-cart-summary-items {
	color: var(--sk-grey3);
}
</style>

<script>
import pluralizeFilterMixin from "@/mixins/pluralize-filter-mixin"

export default {
	name: "CheckoutCartSummary",
	mixins: [pluralizeFilterMixin],
	computed: {
		itemsInCartCount() {
			return this.$store.getters.itemsInCartCount
		}
	},
	methods: {
		cartSummaryClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Cart Summary Clicked"
			})
			this.$emit("cartSummaryClicked")
		}
	}
}
</script>